class MatterCoreCarousel extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.cards = [...this.querySelectorAll('.mc-orbit__card')];
    this.active = 0;
    this.busy = false;
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.interval = Math.max(3, Number(this.dataset.interval) || 5) * 1000;
    this.cards.forEach((card, index) => {
      card.querySelector('button').addEventListener('click', () => this.select(index), options);
      card.querySelector('a').addEventListener('click', event => {
        if (index !== this.active || this.busy) event.preventDefault();
      }, options);
    });
    this.addEventListener('mouseenter', () => this.stop(), options);
    this.addEventListener('mouseleave', () => this.schedule(), options);
    this.addEventListener('focusin', () => this.stop(), options);
    this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
    this.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || this.cards.length < 2) return;
      event.preventDefault();
      this.select((this.active + (event.key === 'ArrowLeft' ? -1 : 1) + this.cards.length) % this.cards.length);
    }, options);
    document.addEventListener('visibilitychange', () => this.schedule(), options);
    this.motion.addEventListener('change', () => this.schedule(), options);
    this.render();
    this.schedule();
  }
  disconnectedCallback() {
    this.abort?.abort();
    this.stop();
    clearTimeout(this.settle);
  }
  stop() { clearTimeout(this.timer); }
  schedule() {
    this.stop();
    if (!this.isConnected || this.busy || this.dataset.autoplay !== 'true' || this.cards.length < 2 || this.motion.matches || document.hidden || this.matches(':hover, :focus-within')) return;
    this.timer = setTimeout(() => this.select((this.active + 1) % this.cards.length), this.interval);
  }
  render() {
    this.cards.forEach((card, index) => {
      const slot = index === this.active ? 'center' : index === (this.active + 1) % this.cards.length ? 'right' : 'left';
      card.dataset.slot = slot;
      const link = card.querySelector('a');
      const button = card.querySelector('button');
      link.tabIndex = slot === 'center' ? 0 : -1;
      link.setAttribute('aria-hidden', String(slot !== 'center'));
      button.hidden = slot === 'center';
      button.setAttribute('aria-label', `${slot === 'left' ? this.dataset.previous : this.dataset.next}: ${link.getAttribute('aria-label')}`);
    });
  }
  select(index) {
    if (this.busy || index === this.active) return;
    this.stop();
    const previous = this.cards[this.active];
    const focused = this.contains(document.activeElement);
    previous.setAttribute('data-retiring', '');
    this.active = index;
    this.busy = true;
    this.render();
    if (focused) this.cards[index].querySelector('a').focus({ preventScroll: true });
    this.settle = setTimeout(() => {
      previous.removeAttribute('data-retiring');
      this.busy = false;
      this.schedule();
    }, this.motion.matches ? 0 : 900);
  }
}
if (!customElements.get('matter-core-carousel')) customElements.define('matter-core-carousel', MatterCoreCarousel);
